import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SpsOptionListComponent } from "../components/index";
import { SpsOptionListFactory } from "../services/index";

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [SpsOptionListComponent],
    providers: [SpsOptionListFactory],
    exports: [SpsOptionListComponent],
    entryComponents: [SpsOptionListComponent]
})
export class SpsOptionListModule {}
